import React, { useEffect, useRef, useState } from 'react';
import Input from '../../../components/Inputs/Input/Input';
import findByVin from '../../../api/cars/findByVin';
import { carSummary, initialIndex, isSameVin, nextIndex, vinSearchQuery } from './vinSearch';
import formatNumber from '../../../utils/formatNumber';

const SEARCH_DELAY_MS = 350;

// ÐÐ¾Ð´ÑÐºÐ°Ð·ÐºÐ° Ð¿Ð»Ð°Ð²Ð°ÐµÑ Ð¿Ð¾Ð²ÐµÑÑ ÑÐ»ÐµÐ´ÑÑÑÐ¸Ñ Ð¿Ð¾Ð»ÐµÐ¹: Ð²Ð½ÑÑÑÐ¸ ÑÑÐµÐ¹ÐºÐ¸ ÑÐµÑÐºÐ¸ Ð¾Ð½Ð° ÑÐ°Ð·Ð´Ð²Ð¸Ð³Ð°Ð»Ð° Ð±Ñ ÑÑÑÐ¾ÐºÑ Ð¸ ÑÐ±Ð¸Ð²Ð°Ð»Ð° Ð²ÑÑÐ°Ð²Ð½Ð¸Ð²Ð°Ð½Ð¸Ðµ.
const box = {
  position: 'absolute',
  top: '100%',
  left: 0,
  zIndex: 30,
  width: 'max(100%, 400px)',
  marginTop: 6,
  padding: 4,
  background: '#fff',
  border: '1px solid #E3E3E3',
  borderRadius: 10,
  boxShadow: '0 8px 24px rgba(5, 20, 31, 0.14)',
};
const row = {
  display: 'flex',
  gap: 12,
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '8px 10px',
  borderRadius: 8,
};
const pick = {
  flexShrink: 0,
  padding: '4px 12px',
  fontSize: 13,
  color: 'var(--brand-primary)',
  background: 'transparent',
  border: '1px solid var(--brand-primary)',
  borderRadius: 6,
  cursor: 'pointer',
};

const describe = (car) => [carSummary(car), car.price ? `${formatNumber(car.price)} â¸` : ''].filter(Boolean).join(' Â· ');

/**
 * ÐÐ¾Ð»Ðµ VIN Ñ Ð¿Ð¾Ð¸ÑÐºÐ¾Ð¼ ÑÐ¶Ðµ Ð·Ð°Ð²ÐµÐ´ÑÐ½Ð½ÑÑ Ð¼Ð°ÑÐ¸Ð½: Ð¿Ð¾ÐºÐ° Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð²Ð²Ð¾Ð´Ð¸Ñ Ð½Ð¾Ð¼ÐµÑ, Ð½Ð¸Ð¶Ðµ Ð¿Ð¾ÑÐ²Ð»ÑÐµÑÑÑ ÑÐ¿Ð¸ÑÐ¾Ðº ÑÐ¾Ð²Ð¿Ð°Ð´ÐµÐ½Ð¸Ð¹
 * (Ð¿Ð¾ Ð»ÑÐ±Ð¾Ð¹ ÑÐ°ÑÑÐ¸ VIN, Ð¾Ñ Ð¿ÑÑÐ¸ Ð·Ð½Ð°ÐºÐ¾Ð²) Ñ ÐºÐ½Ð¾Ð¿ÐºÐ¾Ð¹ Â«ÐÑÐ±ÑÐ°ÑÑÂ» â Ð²ÑÐ¾ÑÑÑ ÐºÐ°ÑÑÐ¾ÑÐºÑ Ð½Ð° ÑÑ Ð¶Ðµ Ð¼Ð°ÑÐ¸Ð½Ñ Ð·Ð°Ð²Ð¾Ð´Ð¸ÑÑ Ð½Ðµ Ð½ÑÐ¶Ð½Ð¾.
 * Ð¡ ÐºÐ»Ð°Ð²Ð¸Ð°ÑÑÑÑ: â/â Ð´Ð²Ð¸Ð³Ð°ÑÑ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐºÑ, Enter Ð²ÑÐ±Ð¸ÑÐ°ÐµÑ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐµÐ½Ð½ÑÑ (ÑÑÐ°Ð·Ñ â Ð¿Ð¾Ð»Ð½Ð¾Ðµ ÑÐ¾Ð²Ð¿Ð°Ð´ÐµÐ½Ð¸Ðµ Ð¸Ð»Ð¸ Ð¿ÐµÑÐ²ÑÑ),
 * Esc Ð·Ð°ÐºÑÑÐ²Ð°ÐµÑ; ÐºÐ»Ð¸Ðº Ð¼Ð¸Ð¼Ð¾ Ð·Ð°ÐºÑÑÐ²Ð°ÐµÑ ÑÐ¾Ð¶Ðµ, Ð´Ð°Ð»ÑÐ½ÐµÐ¹ÑÐ¸Ð¹ Ð²Ð²Ð¾Ð´ Ð¾ÑÐºÑÑÐ²Ð°ÐµÑ ÑÐ¿Ð¸ÑÐ¾Ðº ÑÐ½Ð¾Ð²Ð°.
 */
const VinInput = ({ onPickCar, onSearch, component, ...props }) => {
  const [cars, setCars] = useState([]);
  const [closed, setClosed] = useState(false);
  // ÐÐ°Ð¿ÑÐ¾Ñ Ð² Ð±Ð°Ð·Ñ Ð¸Ð´ÑÑ: Ð¿Ð¾ÐºÐ° Ð¶Ð´ÑÐ¼ Ð¾ÑÐ²ÐµÑ, Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼ Â«ÐÑÐµÐ¼â¦Â», Ð° Ð½Ðµ Ð¿ÑÑÑÐ¾ÑÑ.
  const [loading, setLoading] = useState(false);
  const [active, setActive] = useState(0);
  const wrapper = useRef(null);
  const query = vinSearchQuery(props.value);
  // Ð Ð¾Ð´Ð¸ÑÐµÐ»Ñ Ð¿Ð¾Ð»ÐµÐ·Ð½Ð¾ Ð·Ð½Ð°ÑÑ Ð¸ÑÐ¾Ð³ Ð¿Ð¾Ð¸ÑÐºÐ°: Ð¿Ð¾ Ð½ÐµÐ¼Ñ ÑÐºÑÐ°Ð½ ÑÐ´ÐµÐ»ÐºÐ¸ ÑÐµÑÐ°ÐµÑ, Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÑÑ Ð»Ð¸ ÑÐ¾ÑÐ¼Ñ Ð½Ð¾Ð²Ð¾Ð³Ð¾ Ð°Ð²ÑÐ¾.
  const onSearchRef = useRef(onSearch);
  onSearchRef.current = onSearch;
  const report = (state) => onSearchRef.current && onSearchRef.current({ query, cars: [], done: false, ...state });

  useEffect(() => setClosed(false), [query]);

  useEffect(() => {
    if (!query) {
      setCars([]);
      setLoading(false);
      report({ query: null });
      return undefined;
    }
    // ÐÑÐµÐ¶Ð½Ð¸Ð¹ ÑÐ¿Ð¸ÑÐ¾Ðº Ð¾ÑÐ½Ð¾ÑÐ¸Ð»ÑÑ Ðº Ð´ÑÑÐ³Ð¾Ð¼Ñ Ð½Ð°ÑÐ°Ð»Ñ Ð½Ð¾Ð¼ÐµÑÐ° â ÑÐ±Ð¸ÑÐ°ÐµÐ¼, ÑÑÐ¾Ð±Ñ Ð½Ðµ Ð²ÑÐ±ÑÐ°ÑÑ Ð½Ðµ ÑÐ¾.
    setCars([]);
    setLoading(true);
    report({});
    let cancelled = false;
    const timer = setTimeout(() => {
      findByVin(query)
        .then((res) => {
          const list = Array.isArray(res?.data) ? res.data : [];
          if (cancelled) return;
          setCars(list);
          setLoading(false);
          setActive(initialIndex(list, props.value));
          report({ cars: list, done: true });
        })
        .catch(() => {
          if (cancelled) return;
          setCars([]);
          setLoading(false);
          report({ done: true, failed: true });
        });
    }, SEARCH_DELAY_MS);
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [query]);

  const visible = (cars.length > 0 || loading) && !closed;
  useEffect(() => {
    if (!visible) return undefined;
    const onDown = (event) => {
      if (wrapper.current && !wrapper.current.contains(event.target)) setClosed(true);
    };
    const onKey = (event) => event.key === 'Escape' && setClosed(true);
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDown);
      document.removeEventListener('keydown', onKey);
    };
  }, [visible]);

  const onKeyDown = (event) => {
    if (!visible) return;
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault();
      setActive((index) => nextIndex(index, event.key === 'ArrowDown' ? 1 : -1, cars.length));
    } else if (event.key === 'Enter') {
      // Enter Ð² Ð¿Ð¾Ð»Ðµ VIN Ð½Ðµ Ð´Ð¾Ð»Ð¶ÐµÐ½ Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÑÑÑ ÑÐ¾ÑÐ¼Ñ Ð²Ð¾ÐºÑÑÐ³ â Ð¾Ð½ Ð²ÑÐ±Ð¸ÑÐ°ÐµÑ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐµÐ½Ð½ÑÑ Ð¼Ð°ÑÐ¸Ð½Ñ.
      event.preventDefault();
      if (cars[active] && onPickCar) onPickCar(cars[active]);
    }
  };

  return (
    <div style={{ position: 'relative' }} ref={wrapper} onKeyDown={onKeyDown}>
      <Input {...props} />
      {visible && (
        <div style={box} role="listbox">
          {loading && (
            <div style={{ ...row, color: '#8B8B8B', fontSize: 13, justifyContent: 'flex-start' }}>
              <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true">
                <circle cx="12" cy="12" r="9" fill="none" stroke="#D9D9D9" strokeWidth="3" />
                <path d="M12 3a9 9 0 0 1 9 9" fill="none" stroke="var(--brand-primary)" strokeWidth="3" strokeLinecap="round">
                  <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="0.8s" repeatCount="indefinite" />
                </path>
              </svg>
              ÐÑÐµÐ¼ Ð² Ð±Ð°Ð·Ðµâ¦
            </div>
          )}
          {cars.map((car, index) => (
            <div
              key={car.id}
              role="option"
              aria-selected={index === active}
              style={{
                ...row,
                // ÐÐ¾Ð´ÑÐ²ÐµÑÐµÐ½Ð½Ð°Ñ ÑÑÑÐµÐ»ÐºÐ°Ð¼Ð¸ Ð¸Ð»Ð¸ Ð¼ÑÑÑÑ; Ð¿Ð¾Ð»Ð½Ð¾Ðµ ÑÐ¾Ð²Ð¿Ð°Ð´ÐµÐ½Ð¸Ðµ VIN â Ð·ÐµÐ»ÑÐ½ÑÐ¼: Ð¼Ð°ÑÐ¸Ð½Ð° ÑÐ¾ÑÐ½Ð¾ ÑÐ¶Ðµ Ð·Ð°Ð²ÐµÐ´ÐµÐ½Ð°.
                background: index === active ? '#F0E9DF' : isSameVin(car, props.value) ? '#EAF5EC' : 'transparent',
              }}
              onMouseEnter={() => setActive(index)}
            >
              <div style={{ minWidth: 0 }}>
                <div style={{ fontSize: 14, fontWeight: 600, letterSpacing: 0.3 }}>{car.vin}</div>
                <div style={{ fontSize: 12, color: '#8B8B8B', marginTop: 2 }}>{describe(car) || 'Ð±ÐµÐ· Ð¾Ð¿Ð¸ÑÐ°Ð½Ð¸Ñ'}</div>
              </div>
              <button type="button" style={pick} onClick={() => onPickCar && onPickCar(car)}>
                ÐÑÐ±ÑÐ°ÑÑ
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default VinInput;
